import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  constructor(private readonly router: Router) {}

  readonly cards = [
    {
      title: 'Beginner Mode',
      subtitle: 'Quick Exercise',
      description:
        'Build a guided scenario in a few steps with prompts tuned for quick facilitation and rapid tabletop preparation.',
      buttonLabel: 'Start Exercise',
      illustration: 'analytics',
    },
    {
      title: 'Advanced Mode',
      subtitle: 'Full Design Suite',
      description:
        'Design a full exercise package with richer inputs, scenario controls, inject planning, and deeper customization.',
      buttonLabel: 'Start Exercise',
      illustration: 'studio',
    },
    {
      title: 'Smartphone Mode',
      subtitle: 'Touch Interface',
      description:
        'Launch a mobile-first workflow optimized for touch interactions, quick edits, and facilitation on the move.',
      buttonLabel: 'Start Exercise',
      illustration: 'mobile',
    },
  ] as const;

  startExercise(title: string): void {
    if (title === 'Advanced Mode') {
      void this.router.navigate(['/advanced-mode']);
    }
  }
}
